'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tinymce = require('tinymce/tinymce');

var _tinymce2 = _interopRequireDefault(_tinymce);

require('tinymce/themes/modern/theme');

require('tinymce/plugins/advlist');

require('tinymce/plugins/autolink');

require('tinymce/plugins/lists');

require('tinymce/plugins/link');

require('tinymce/plugins/image');

require('tinymce/plugins/charmap');

require('tinymce/plugins/print');

require('tinymce/plugins/preview');

require('tinymce/plugins/hr');

require('tinymce/plugins/anchor');

require('tinymce/plugins/pagebreak');

require('tinymce/plugins/searchreplace');

require('tinymce/plugins/visualblocks');

require('tinymce/plugins/code');

require('tinymce/plugins/fullscreen');

require('tinymce/plugins/insertdatetime');

require('tinymce/plugins/nonbreaking');

require('tinymce/plugins/save');

require('tinymce/plugins/table');

require('tinymce/plugins/visualchars');

require('tinymce/plugins/contextmenu');

require('tinymce/plugins/directionality');

require('tinymce/plugins/paste');

require('tinymce/plugins/textcolor');

require('tinymce/plugins/colorpicker');

require('tinymce/plugins/textpattern');

require('tinymce/plugins/imagetools');

require('tinymce/plugins/toc');

require('tinymce/plugins/autoresize');

require('tinymce/plugins/media');

var _template = require('./template.html');

var _template2 = _interopRequireDefault(_template);

var _controller = require('./controller');

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Plugins
// Core - these two are required :-)
exports.default = {
  restrict: 'E',
  bindings: {},
  template: _template2.default,
  controller: _controller2.default

  // WEBPACK FOOTER //

};


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-page/components/add/index.js
 **/